import React, { useEffect, useState } from "react";
import ReactQuill, { Quill } from "react-quill";
import "react-quill/dist/quill.snow.css";
import { RollingLoader } from "../commons";
import useDebounce from "../../customHooks/useDebounce";
import "./Editor.scss";

import ImageResize from "quill-image-resize-module-react";
import { PaperClipIcon } from "../Icon";
import {
  downloadLink,
  imagePreview,
  renderUploadedFiles,
} from "../../utils/invoiceGeneration/commonFunctions";
import UploadModalWithFileManager from "../InvoiceGeneration/UploadModal/UploadModalWithFileManager";
import ImagePreview from "../FileManager/Files/ImagePreview";
Quill.register("modules/imageResize", ImageResize);
let SizeStyle = Quill.import("attributors/style/size");
SizeStyle.whitelist = ["10px", "15px", "18px", "20px", "32px", "54px"];
Quill.register(SizeStyle, true);

const toolbarOptions = [
  ["bold", "italic", "underline", "strike"], // toggled buttons
  ["blockquote", "code-block"],
  [{ list: "ordered" }, { list: "bullet" }],
  [{ script: "sub" }, { script: "super" }],
  [{ indent: "-1" }, { indent: "+1" }],
  [{ direction: "rtl" }],
  [{ header: [1, 2, 3, 4, 5, 6, false] }],
  [{ color: [] }, { background: [] }],
  [{ font: [] }],
  [{ align: [] }],
  ["clean"],
  ["link", "image", "video"], // Include CustomImageComponent
];

type AppProps = {
  token: string | null;
  history: any;
  type?:string;
  isEdit?: boolean;
  singleSopDetails?: any;
  uniqueCheckFileNameFetching: boolean;
  uniqueCheckFileNameMessage: string;
  handleSubmitData: (data: any) => void;
  uniqueFileNameCheck: (fileName: string) => void;
  clientCode?: number;
  fileManagerFetching: boolean;
};

const AddEditSopModuleForm = ({
  token,
  history,
  isEdit,
  type,
  handleSubmitData,
  singleSopDetails,
  uniqueCheckFileNameFetching,
  uniqueCheckFileNameMessage,
  uniqueFileNameCheck,
  fileManagerFetching,
  clientCode,
}: AppProps) => {
  let blobBaseUrl = process.env.REACT_APP_BLOB_BASE_URL;
  let blobToken = process.env.REACT_APP_BLOB_TOEKN;
  const [fileData, setFileData] = useState("");
  const [fileName, setFileName] = useState("");
  const [fontSize, setFontSize] = useState("14px"); // Default font size
  const [modal, toggleModal] = useState<boolean>(false);
  const [uploadData, setUploadData] = useState<any>([]);
  const [imageDetails, setImageDetails] = useState<any>({
    imageUrl: "",
    downloadImage: "",
    fileType: "",
    finalFileName: "",
    updateBy: "",
    updatedAt: "",
  });
  const [showFileUploadModal, setShowFileUploadModal] =
    useState<boolean>(false);
  const [showPopUpContentModal, setShowPopUpContentModal] =
    useState<boolean>(false);

  useEffect(() => {
    if (isEdit && singleSopDetails) {
      setFileData(singleSopDetails?.file_data);
      setFileName(singleSopDetails?.file_name);
      setUploadData(
        singleSopDetails?.uploads ? [...singleSopDetails?.uploads] : []
      );
    }
  }, [singleSopDetails]);

  const resetImageUrl = () => {
    setImageDetails({
      imageUrl: "",
      downloadImage: "",
      fileType: "",
      finalFileName: "",
      updateBy: "",
      updatedAt: "",
    });
  };
  const getImageDetails = (data: any) => {
    setImageDetails({
      ...data,
      imageUrl: blobBaseUrl + data.file_url + "?" + blobToken,
      downloadImage: data.file_url,
      fileType: data.file_type,
      finalFileName: data.file_name,
    });
  };

  useDebounce(
    () => {
      if (fileName) {
        let finalData: any = {
          fileName: fileName?.trim(),
        };
        uniqueFileNameCheck(finalData);
      }
    },
    500,
    [fileName]
  );

  const handleInputDetailschange = (data: string) => {
    setFileName(data);
  };

  const showUploadModal = () => {
    setShowFileUploadModal(!showFileUploadModal);
  };

  const handleSubmitForm = () => {
    if (fileName?.trim()) {
      const finalData = {
        fileName,
        fileData,
        uploads: uploadData,
      };
      handleSubmitData(finalData);
    }
  };

  const handleToggleFileUploadModal = () => {
    setShowFileUploadModal(!showFileUploadModal);
  };

  const handleEditFileList = (index: number) => {
    setShowPopUpContentModal(false);
    const tempFileData = JSON.parse(JSON.stringify(uploadData));

    const isFilePresent = tempFileData?.find((data: any, idx: number) => {
      return idx === index;
    });

    if (!!isFilePresent) {
      let newData = tempFileData?.filter(
        (data: any, idx: number) => idx !== index
      );
      setUploadData(newData);
    }
  };

  const removeDuplicate = (data: any) => {
    let nonRepeatData: any = new Set();

    data?.forEach(
      (obj: any) =>
        !nonRepeatData.has(JSON.stringify(obj)) &&
        nonRepeatData.add(JSON.stringify(obj))
    );

    let finalData: any = new Set(
      [...nonRepeatData].map((item) => JSON.parse(item))
    );
    return finalData;
  };

  const handleUploadFile = (data: any) => {
    setShowFileUploadModal(false);
    let finalData: any = removeDuplicate(data);
    setUploadData(Array.from(finalData));
  };

  const handleUploadFileFromFileManager = (data: any) => {
    let finalData: any = removeDuplicate(data);
    setUploadData(Array.from(finalData));
  };

  const renderFilesList = () => {
    const isDelete = type==="adminReport" ? false :true;
    const finalFileList =
      uploadData?.length > 0 &&
      uploadData?.map((data: any, index: number) => {
        let file_type = data.file_url.split(".");
        return file_type[file_type.length - 1].toLowerCase() === "png" ||
          file_type[file_type.length - 1].toLowerCase() === "jpg" ||
          file_type[file_type.length - 1].toLowerCase() === "jpeg" ||
          file_type[file_type.length - 1].toLowerCase() === "doc" ||
          file_type[file_type.length - 1].toLowerCase() === "docx" ||
          file_type[file_type.length - 1].toLowerCase() === "xls" ||
          file_type[file_type.length - 1].toLowerCase() === "xlsx" ||
          file_type[file_type.length - 1].toLowerCase() === "pdf"
          ? imagePreview(
              data,
              index,
              getImageDetails,
              handleEditFileList,
              setShowPopUpContentModal,
              isDelete
            )
          : downloadLink(
              data,
              index,
              getImageDetails,
              handleEditFileList,
              setShowPopUpContentModal,
              isDelete
            );
      });

    return finalFileList;
  };
  return (
    <>
      <div style={{ marginBottom: "110px" }}>
        <div className="row mb-5">
          <div className="col-md-4 pt-1">
            <div style={{ position: "relative" }}>
              <label htmlFor="File Name">
                File Name<span className="color-red">*</span>
              </label>
              <input
                name="fileName"
                type="text"
                disabled={type==="adminReport"}
                className="form-control"
                value={fileName}
                onChange={(e) => handleInputDetailschange(e.target.value)}
              />
              <div style={{ position: "absolute", top: "22px", right: "0px" }}>
                {uniqueCheckFileNameFetching && <RollingLoader />}
              </div>
            </div>
            {fileName &&
              uniqueCheckFileNameMessage &&
              uniqueCheckFileNameMessage?.includes("already exists") && (
                <small className="text-danger">
                  File Name is already in use!
                </small>
              )}
          </div>
          <div
            className={`col-md-8  d-flex align-items-center ${
              !!uploadData?.length ? "" : "pt-4"
            }`}
          >
            <div>
              
             {type!=="adminReport" ? <div className="d-flex align-items-center justify-center" style={{gap:"15px", marginTop:uploadData?.length ? "25px" : ""}}>
              <button
                className={`btn btn-outline`}
                onClick={() => {
                  showUploadModal();
                }}
              >
                + Upload File
              </button>

              {!!uploadData?.length && (
                <div
                  className={`pointer ${!!uploadData?.length ? "pb-1" : ""}`}
                >
                  <span id="Popover1">
                    <PaperClipIcon />
                    <span className="badge count-badge" style={{left:"165px"}}>
                      {uploadData?.length}
                    </span>
                  </span>
                </div>
              )}
              </div> : null}
              

              {renderUploadedFiles(
                showPopUpContentModal,
                setShowPopUpContentModal,
                renderFilesList
              )}
            </div>
          </div>
        </div>

        <ReactQuill
          id="editor"
          value={fileData}
          readOnly={type==="adminReport" ? true : false}
          onChange={setFileData}
          modules={{
            toolbar:  type==="adminReport" ? false : toolbarOptions,
            imageResize: {
              modules: ["Resize", "DisplaySize"],
            },
          }}
          style={{ height: "50vh", fontSize: "16px", fontFamily: "sans-serif" ,  backgroundColor: type==="adminReport" ? '#F5F5F5' : "#fff" }}
        />
      </div>
      <hr></hr>
      <div className="row mt-3">
        <div className="col-md-12 text-right">
          <button
            className="btn"
            style={{ border: "1px solid #bfcbe1", marginRight: "15px" }}
            onClick={() => {
              history.goBack();
            }}
          >
            {type==="adminReport" ? "Exit" : "Cancel"}
          </button>
          {type!=="adminReport" ?<button
            className="btn btn-primary"
            onClick={handleSubmitForm}
            disabled={
              !fileName?.trim() ||
              uniqueCheckFileNameMessage?.includes("already exists")
            }
          >
            {isEdit ? "Update" : "Save"}
          </button> : null}
        </div>
      </div>

      {imageDetails?.imageUrl?.length != 0 && (
        <ImagePreview
          resetImageUrl={resetImageUrl}
          imageDetails={imageDetails}
        />
      )}

      {showFileUploadModal ? (
        <UploadModalWithFileManager
          type={"invoice"}
          isDropZone={true}
          modal={showFileUploadModal}
          toggleModal={handleToggleFileUploadModal}
          client_code={clientCode}
          setUploadData={setUploadData}
          uploadData={uploadData}
          token={token}
          setShowFileUploadModal={setShowFileUploadModal}
          handleUploadFile={handleUploadFile}
          handleUploadFileFromFileManager={handleUploadFileFromFileManager}
          fetching={fileManagerFetching}
          isDraggableModal
        />
      ) : null}
    </>
  );
};

export default AddEditSopModuleForm;
